import * as React from 'react';
import { DataAggregateVO, TblAggregateType } from './FinalTableProps';
import {
  mcAggregation,
  mcCheck,
  mcMaximum,
  mcMean,
  mcMinimum,
  mcSum,
} from '@mc/react-ui-icons';
import { MenuItem } from '../menu/MenuItem';
import { Icon } from '../icon/Icon';

export const getIcon = (type?: TblAggregateType) => {
  switch (type) {
    case 'sum':
      return mcSum;
    case 'avg':
      return mcMean;
    case 'min':
      return mcMinimum;
    case 'max':
      return mcMaximum;
    case 'count':
    case 'none':
    default:
      return mcAggregation;
  }
};

export const getLabel = (type?: TblAggregateType, altDefault?: boolean) => {
  switch (type) {
    case 'sum':
      return 'Součet';
    case 'avg':
      return 'Průměr';
    case 'min':
      return 'Minimum';
    case 'max':
      return 'Maximum';
    case 'count':
    case 'none':
    default:
      return altDefault ? 'Agregační funkce' : 'Vypnuto';
  }
};

export const getMenuItem = (
  setAggregate: (type?: TblAggregateType) => () => void,
  aggregate?: DataAggregateVO,
  type?: TblAggregateType
) => {
  return (
    <MenuItem
      onClick={setAggregate(type)}
      text={getLabel(type)}
      icon={aggregate?.aggregate === type && <Icon icon={mcCheck} />}
    />
  );
};
